<template>
<div>
<ContentHeader :title="$store.state.languages.lang_phrases.sonuc_ekrani"  url="FlowCustomResultDisplays" :show_button="true"  icon="arrow-left" buttontype="danger" :label="$store.state.languages.lang_phrases.geri_don"></ContentHeader>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">
<div class="mt-4">
<div class="grid">
<div class="col-12">

<ClickEditInputText  :title="$store.state.languages.lang_phrases.isim" :value="item.name" valkey="name" @dataChanged="dataChanged" />
<ClickEditSwitch  :title="$store.state.languages.lang_phrases.aktif" :value="item.active" valkey="active" @dataChanged="dataChanged" />
<ClickEditSwitch  :title="$store.state.languages.lang_phrases.tedarikcilerle_paylas" :value="item.share_with_suppliers" valkey="share_with_suppliers" @dataChanged="dataChanged" />

</div>

<div class="col-12"><h4 class="text-primary">Tasarım</h4></div>
<div class="col-12">
<template v-if="item.theschema">
	
</template>

<template v-else>
<Button 
label="Yeni Tasarım Oluşturun" 
id="editor_open_button" 
class=" p-button-primary p-button-outlined  p-button-sm" 
@click="openSchemaEditor"></Button>
</template>

</div>

</div>
</div>

</template>

<SchemaEditor 
ref="schema_editor"
/>
</div>
</template>

<script>
import SchemaEditor from "./SchemaEditor"
export default {

  name: 'FlowCustomResultDisplay',
  data () {
    return {
    	loading:true,
    	item:null,
    }
  },
  components:{SchemaEditor},
  mounted()
  {
  	this.getData()
  },
  methods:{
  	openSchemaEditor()
  	{
  		let coords = document.getElementById("editor_open_button").getBoundingClientRect();
  		this.$refs.schema_editor.openSchemaEditor(coords.left,coords.top)
  	},
  	dataChanged(data)
    {
      let formdata = new FormData()      
      formdata.append(data.key,data.value)
      this.generalSubmission(formdata,"flow_custom_display/"+this.$route.params.display_id,this.afterdataChanged)
    },
    async afterdataChanged(response)
    {
    	this.item = response.data      
    },
  	async getData()
  	{
  		this.item = await this.generalApiGetWithoutLoader("flow_custom_display/"+this.$route.params.display_id)
  		console.log(this.item)
  		this.loading = false
  	}
  }
}
</script>

<style lang="css" scoped>


</style>